export default __webpack_public_path__ + "static/media/397.f2d4474b.jpg";